import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d3b630c2"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "SHEET #", -1));
const _hoisted_2 = {
  class: "label"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Description", -1));
const _hoisted_4 = {
  class: "label"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Format", -1));
const _hoisted_6 = {
  class: "label"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Option", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Quantity", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Price", -1));
const _hoisted_10 = {
  class: "label"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_delete_icon = _resolveComponent("delete-icon");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_card = _resolveComponent("el-card");
  return !_ctx.isDeleting ? (_openBlock(), _createBlock(_component_el_card, {
    key: 0,
    class: "card"
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: "delete-icon",
      onClick: _cache[0] || (_cache[0] =
      //@ts-ignore
      (...args) => _ctx.handleDelete && _ctx.handleDelete(...args))
    }, [_createVNode(_component_delete_icon, {
      size: 16
    })]), _createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        xs: 24,
        sm: 24,
        md: 9,
        class: "fb label",
        span: 9
      }, {
        default: _withCtx(() => [_hoisted_1]),
        _: 1
      }), _createVNode(_component_el_col, {
        xs: 24,
        sm: 24,
        md: 15,
        span: 15
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.item.name), 1)]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        xs: 24,
        sm: 24,
        md: 9,
        class: "fb label",
        span: 9
      }, {
        default: _withCtx(() => [_hoisted_3]),
        _: 1
      }), _createVNode(_component_el_col, {
        xs: 24,
        sm: 24,
        md: 15,
        span: 15
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.description), 1)]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        xs: 24,
        sm: 24,
        md: 9,
        class: "fb label",
        span: 9
      }, {
        default: _withCtx(() => [_hoisted_5]),
        _: 1
      }), _createVNode(_component_el_col, {
        xs: 24,
        sm: 24,
        md: 15,
        span: 15
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.format), 1)]),
        _: 1
      })]),
      _: 1
    }), _ctx.format === 'Paper' && _ctx.optionsField && _ctx.$props.showPurchaseOptions || _ctx.format === 'Image' && _ctx.optionsField ? (_openBlock(), _createBlock(_component_el_row, {
      key: 0,
      align: "middle"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        xs: 24,
        sm: 24,
        md: 9,
        class: "fb label",
        span: 9
      }, {
        default: _withCtx(() => [_hoisted_7]),
        _: 1
      }), _createVNode(_component_el_col, {
        xs: 24,
        sm: 24,
        md: 15,
        span: 15
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: _ctx.optionsField.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.optionsField.value = $event),
          onChange: _ctx.handleChange,
          size: "small",
          disabled: _ctx.optionsField.options?.length === 1
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsField.options, option => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: option.name,
              label: `${option.name?.toUpperCase()} ${option.priceModifier ? `[+${option.priceModifier}]` : ''}`,
              value: option.name
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "onChange", "disabled"])]),
        _: 1
      })]),
      _: 1
    })) : _createCommentVNode("", true), (_ctx.item.maxQuantity ?? Infinity) > 1 && _ctx.$props.showPurchaseOptions ? (_openBlock(), _createBlock(_component_el_row, {
      key: 1,
      align: "middle"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        class: "fb label",
        span: 9
      }, {
        default: _withCtx(() => [_hoisted_8]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 15
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          size: "small",
          min: _ctx.item.minQuantity ?? 1,
          max: _ctx.item.maxQuantity ?? Infinity,
          modelValue: _ctx.item.quantity,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.item.quantity = $event),
          onChange: _ctx.handleChange
        }, null, 8, ["min", "max", "modelValue", "onChange"])]),
        _: 1
      })]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.$props.showPurchaseOptions ? (_openBlock(), _createBlock(_component_el_row, {
      key: 2
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        xs: 24,
        sm: 24,
        md: 9,
        class: "fb label",
        span: 9
      }, {
        default: _withCtx(() => [_hoisted_9]),
        _: 1
      }), _createVNode(_component_el_col, {
        xs: 24,
        sm: 24,
        md: 15,
        span: 15
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.formattedPrice), 1)]),
        _: 1
      })]),
      _: 1
    })) : _createCommentVNode("", true)]),
    _: 1
  })) : _createCommentVNode("", true);
}